import RKeys from 'ramda/src/keys'

// Literally the only reason to use this over Object.keys is that Object.keys will
// assume that the keys are strings, which is annoying
export default RKeys
